<template>
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'all'" ref="headers"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="my">
        <section class="mySection">
          <!--로그인 시(s)-->
          <div class="stateLogin" style="padding-bottom: 0">
            <span class="state">
              <em>{{ userInfo.userName }}님</em>
              , 환영합니다.
            </span>
            <a href="javascript:void(0);" @click="authAccount" class="btn_s m">정보 관리</a>
          </div>
          <!-- <a href="javascript:void(0);" @click="logout" class="btn_s m">로그아웃 ( 임시버튼 )</a> -->
          <br />
          <!--로그인 시(e)-->
          <!--<div>{{ userInfo }}</div>-->
          <ul class="mpStateInfo">
            <li>
              <a @click="$router.push({ name: 'benefitsCoupon', params: { downCoupon: false } })">
                <span class="item">
                  쿠폰
                  <i>{{ myPageSummary.couponCount | currency }}</i>
                </span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="icoBtn zzim" @click="$router.push('/wishList')">
                <span>
                  찜
                  <i>{{ myPageSummary.wishCount | currency }}</i>
                </span>
              </a>
            </li>
          </ul>
        </section>
        <section class="hr mySection">
          <div class="titArea">
            <h2 class="titH5 normal">주문/배송 상품</h2>
          </div>
          <ul class="mpUserState">
            <li style="width: 50%">
              <a @click="$router.push({ name: 'myOrderList', params: { tab: true } })">
                <span class="item">렌탈</span>
                <p class="val" :class="{ point: myPageSummary.rentalCount > 0 }">{{ myPageSummary.myRentalCount | currency }}</p>
              </a>
            </li>
            <li style="width: 50%">
              <a @click="$router.push({ name: 'myOrderList', params: { tab: false } })">
                <span class="item">구매</span>
                <p class="val" :class="{ point: myPageSummary.purchaseCount > 0 }">{{ myPageSummary.purchaseCount | currency }}</p>
              </a>
            </li>
            <!--<li>-->
            <!--<a href="javascript:void(0);">-->
            <!--<span class="item">정기배송</span>-->
            <!--<p class="val" :class="{ point: myPageSummary.deliveryCount > 0 }">{{ myPageSummary.deliveryCount | currency }}</p>-->
            <!--</a>-->
            <!--</li>-->
          </ul>
        </section>

        <section class="hr mySection mb0" v-if="myPageSummary.billInfo.length > 0">
          <div class="mpSlide slide autoH" id="slide1">
            <ul class="slideList">
              <li v-for="(billInfo, index) in myPageSummary.billInfo" :key="index">
                <div class="mpPrdInfo">
                  <p class="prdTit">{{ billInfo.productName }}</p>
                  <div class="prdPrice">
                    <p class="tit">{{ billInfo.thisMonth }}월 청구금액</p>
                    <p class="price">
                      <em>{{ billInfo.thisMonthAmount | currency }}</em>
                      원
                    </p>
                    <a @click="$router.push({ name: 'myPaymentInfo', params: { oderId: billInfo.orderId } })" class="links arrow">자세히 보기</a>
                  </div>
                  <div class="mpPayUnpaid" v-if="billInfo.overdueAmounts > 0">
                    미납금액
                    <span>{{ billInfo.overdueAmounts | currency }}</span>
                    원
                    <a @click="$router.push('/unPayment')" class="links arrow">결제하기</a>
                  </div>
                  <div class="mpPayInfo" v-if="billInfo.payInfo.payMethod == '카드'">
                    <p>
                      결제수단 :
                      <span>[{{ billInfo.payInfo.payMethod }}] {{ billInfo.payInfo.cardName }} {{ billInfo.payInfo.cardNumber }}</span>
                    </p>
                    <p>
                      결제일 :
                      <span>매월 {{ billInfo.payInfo.payDate }}일</span>
                    </p>
                  </div>
                  <div class="mpPayInfo" v-else-if="billInfo.payInfo.payMethod == '계좌'">
                    <p>
                      결제수단 :
                      <span>[{{ billInfo.payInfo.payMethod }}] {{ billInfo.payInfo.bankName }} {{ billInfo.payInfo.accountNumber }}</span>
                    </p>
                    <p>
                      결제일 :
                      <span>매월 {{ billInfo.payInfo.payDate }}일</span>
                    </p>
                  </div>
                </div>
                <div class="btnArea nowrap">
                  <button type="button" class="btn_s m" @click="monthPrePayment(billInfo)">당월선결제</button>
                  <!-- // 22.04.22 김근유 대리님 요청건 ( 할부상품 노출관련 ) -->
                  <!-- 렌탈료 선납할인 버튼 주석 해제 후, 기존 버튼 삭제 -->
                  <!-- <button v-if="billInfo.ordrDivCd=='RORT00GE'" type="button" class="btn_s m" @click="rentalPrePayDiscount(billInfo)">렌탈료선납할인</button> -->
                  <button type="button" class="btn_s m" @click="rentalPrePayDiscount(billInfo)">렌탈료선납할인</button>
                  <button type="button" class="btn_s m" @click="changeBillInfo(billInfo)">결제수단 변경</button>
                </div>
              </li>
            </ul>
          </div>
        </section>


        <!-- <img
                    src="@/../static/img/mw/content/img_banner_mp.png"
                    alt="나도 친구도 1+1 더블 혜택. 내 추천코드로 렌탈 이용 시, 3개월 이용료 면제!"
                  /> -->
        <section class="full hr mb0">
          <ul class="bannerList">
            <!-- TODO 친구추천 -->
            <li v-for="(banner, index) in bannerList" :key="index">
              <a @click="$router.push('/friendRecommend')">
                <span class="img">
                  <img :src="banner.imgURL" :alt="banner.bannerName" />
                </span>
              </a>
            </li>
          </ul>
        </section>


        <section class="full hr mb0">
          <ul class="pageLinkBox btNone">
            <li>
              <a @click="$router.push('/affiliateCard')">제휴카드</a>
            </li>
            <li>
              <a href="javascript:void(0);" @click="$router.push('/asInfo')">A/S 신청</a>
            </li>
            <li>
              <a href="javascript:void(0);" @click="$router.push('/maintenance')">정기점검</a>
            </li>
            <li>
              <a href="javascript:void(0);" @click="$router.push('/changeInstallInfo')">이전설치</a>
            </li>
            <li>
              <a href="javascript:void(0);" @click="$router.push('/myVoucher')">증빙서류 발급</a>
            </li>
            <li>
              <a href="javascript:void(0);" @click="$router.push('/changeAccount')">명의변경</a>
            </li>
          </ul>
        </section>
        <section class="full hr mb0" v-show="basketCount > 0">
          <ul class="pageLinkBox btNone">
            <li class="mpPageLink">
              <a @click="$router.push({ name: 'cartRental' })">
                장바구니에 상품이
                <span>주문을 기다리고 있어요!</span>
              </a>
            </li>
          </ul>
        </section>
        <section class="full hr mb0">
          <ul class="pageLinkBox btNone">
            <li>
              <a @click="$router.push('/myUsedRental')">
                이용중인 렌탈
                <span class="num point">{{ myPageSummary.useRentalCount }}</span>
              </a>
            </li>
            <!--<li>-->
            <!--<a>-->
            <!--정기배송 관리-->
            <!--<span class="num">{{ myPageSummary.deliveryCount }}</span>-->
            <!--</a>-->
            <!--</li>-->
            <li>
              <a @click="$router.push('/myOrderList')">
                주문/배송 조회
                <span class="num">{{ myPageSummary.orderCount }}</span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" @click="$router.push('/myQna')">
                1:1 문의
                <span class="num point">{{ myPageSummary.qnaCount }}</span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" @click="$router.push('/productInquiry')">
                상품 문의
                <span class="num">{{ myPageSummary.productQnaCount }}</span>
              </a>
            </li>
            <li>
              <a @click="$router.push({ name: 'myReview' })">
                나의 리뷰
                <span class="num point">{{ myPageSummary.reviewCount }}</span>
              </a>
            </li>
          </ul>
        </section>
        <section v-if="incomingType === 'nativeApp'" class="full hr mb0">
          <ul class="pageLinkBox btNone">
            <li>
              <a @click="$router.push('/setting')">앱 설정</a>
            </li>
          </ul>
        </section>
        <section class="hr">
          <div class="mpTelBox">
            <a class="tel" href="tel:1670-0202">1670-0202</a>
            <p>평일 09:00 ~ 18:00</p>
            <p>welrix@welrixrental.co.kr</p>
          </div>
          <div class="btnArea two half">
            <button type="button" class="btn_s m" @click="$router.push('/customerCenter')">고객센터</button>
            <button type="button" class="btn_s m" @click="kakao">카카오톡 상담</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->


      <QuickMenu></QuickMenu>
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>


    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
</template>


<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import QuickMenu from '@/views/app/comm/QuickMenu';
import * as customjs from '@/../static/js/m.front.js';
import { OVERDUE_AMOUNT_FOR_PAY_CHG_CHECK } from '@/store/message.type';
import MessagePop from '@/components/popup/MessagePop';


export default {
  name: 'MyPage',
  components: {
    QuickMenu,
    MessagePop,
  },
  data: function () {
    return {
      headerTitle: '마이페이지',
      userInfo: JwtService.getUserInfo(),
      myPageSummary: {
        asCount: 0,
        billInfo: [],
        changeOwnCount: 0,
        couponCount: 0,
        deliveryCount: 0,
        documentCount: 0,
        moveFitCount: 0,
        orderCount: 0,
        productQnaCount: 0,
        purchaseCount: 0,
        qnaCount: 0,
        myRentalCount: 0,
        rentalCount: 0,
        reviewCount: 0,
        scheduleCount: 0,
        useRentalCount: 0,
        wishCount: 0,
      },
      bannerList: [],
      basketCount: 0,
      messagePop: false,
      bizDate5: '',
      incomingType: '',
    };
  },
  created() {
    if (navigator.userAgent.match(/RIX/i)) {
      this.incomingType = 'nativeApp';
      return this.incomingType;
    }
  },
  mounted() {
    // this.userInfo = JwtService.get();
    this.selectMyPageSummary();
    this.selectBannerList();
    this.getBizDate5();
  },
  updated() {
    customjs.slideInit('#slide1', false, false, 300, true, 'auto', 10, 'fraction');
    this.basketCount = this.$refs.headers._data.basketCount;
  },
  methods: {
    selectMyPageSummary() {
      ApiService.service('GET', '/user/auth/mypage/summary')
        .then(({ data }) => {
          console.log(data);
          this.myPageSummary = data.result;
          // TODO 렌탈 이용상품이 없을경우 경우 체크
          // this.myPageSummary.billInfo = [];
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    getBizDate5() {
      ApiService.service('GET', '/common/businessDay/5')
        .then(({ data }) => {
          this.bizDate5 = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectBannerList() {
      ApiService.service('GET', '/resource/banner/30')
        .then(({ data }) => {
          // console.log(data);
          this.bannerList = data.result[0].bannerDtos;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    logout() {
      JwtService.logout();
      this.$router.replace('/');
    },
    kakao() {
      if (/iPhone/i.test(navigator.userAgent)) {
        window.iosKakaoTalk();
      } else {
        window.location.href = 'https://pf.kakao.com/_WCcJd/chat';
      }
    },
    authAccount() {
      let path = '/authAccount';
      if (this.userInfo.snsLoginYn == 'Y') path = '/snsAuthAccount';
      this.$router.push(path);
    },
    changeBillInfo(billInfo) {
      // 결제수단 변경
      // 미납금 체크
      if (billInfo.overdueAmounts > 0) {
        this.msg = OVERDUE_AMOUNT_FOR_PAY_CHG_CHECK;
        this.messagePop = true;
        return;
      }


      this.$router.push({ name: 'changePaymentMethod', params: { billInfo: billInfo } });
    },
    // 메세지 팝업창 닫기
    close() {
      this.messagePop = false;
      this.$emit('close');
    },
    checkRestDays(billInfo) {
      if (billInfo.nextAskDtm < this.bizDate5) {
        this.msg = '결제일로부터 5영업일 이전에는 이용하실 수 없습니다.';
        this.messagePop = true;
        return false;
      }
      return true;
    },
    monthPrePayment(billInfo) {
      //console.log('당월 선결제 : orderId >> ' + billInfo.orderId + '  nextAskDtm >> ' + billInfo.nextAskDtm + ' bizDate5 >> ' + this.bizDate5);
      if (this.checkRestDays(billInfo)) {
        this.$router.push({ name: 'monthPrePayment', params: { orderId: billInfo.orderId } });
      }
    },
    rentalPrePayDiscount(billInfo) {
      // console.log('당월 선결제 : orderId >> ' + billInfo.orderId + '  nextAskDtm >> ' + billInfo.nextAskDtm + ' bizDate5 >> ' + this.bizDate5);

      if ( this.checkRestDays(billInfo) ) {
        this.$router.push({ name: 'rentalPrePayDiscount', params: { orderId: billInfo.orderId } });
      }
    },
  },
};
</script>
